Vendd.Scripts.load(function () {
    var $wrapper = $('.x-product-list-gtl'), wrapper;

    if ($wrapper.length < 1) return; 

    wrapper = $wrapper.get(0);

    var $configuration, configuration, jsonConfiguration, 
        isScrolled = $wrapper.data('scrolled') === true,
        forwardUpdates = 0,
        forwardUpdatesCup = 2,
        backwardUpdates = 0,
        backwardUpdatesCup = 0;

    var model = {};

    $configuration = $('.configuration', $wrapper);

    configuration = $configuration.text();

    if (configuration)
        jsonConfiguration = JSON.parse(configuration);

    wrapper.getConfiguration = function () { return configuration; };

    var loading = false, hasNext = true, hasPrevious = true, initialCall = true;

    wrapper.loading = function (option, direction) {
        loading = option;
        if (option === true) {
            $('.scrolllist-pager-notification[data-direction="' + direction + '"]').addClass('disabled');
            $('.scrolllist-pager-notification[data-direction="' + direction + '"]').addClass('x-loading');
        } else {
            if (direction === 'forward') {
                if (forwardUpdates >= forwardUpdatesCup) {
                    $('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled');
                    $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled x-loading');
                }
            }
            else if (direction === 'backward') {
                if (backwardUpdates >= backwardUpdatesCup) {
                    $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled');
                    $('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled x-loading');
                }
            } else {
                $('.scrolllist-pager-notification').removeClass('disabled x-loading');
            }
        }
    };

    wrapper.onSuccess = function (envelope) {

        if (envelope.message.data.list !== wrapper) return;

        var direction = '';

        model = envelope.message.data.model;

        if (model.Items.length === 0) {

            if (envelope.message.data.position == 'BottomOfList') {
                hasNext = false;
                direction = 'forward';
            }
            if (envelope.message.data.position == 'TopOfList') {
                hasPrevious = false;
                direction = 'backward';
            }
            if (envelope.message.data.position != 'Reload') {
                wrapper.loading(false, direction);
                return;
            }
        }

        var html = Vendd.Handlebars.parse("getTheLookList_A", model);

        var $html = $(html),
            $list = $('> ul', $wrapper),
            $boxes,
            items, lastItem, grouping, rowSize;

        configuration = $('.configuration', $html).text();

        Vendd.MessageBus.publish(wrapper, new Vendd.Widget.Messages.BindControl($html));

        $boxes = $('.x-product-box-gtl', $html);

        lastItem = $list.children().last();
        grouping = $html.data('grouping');
        rowSize = 3;

        items = wrapBoxes($boxes, grouping, rowSize, lastItem, model);

        if (envelope.message.data.position == 'BottomOfList') {
            if (parseInt($wrapper.attr('data-total-pages')) == model.PageNumber) {
                $('.scrolllist-pager-notification[data-direction="forward"]').addClass('hidden');
                $('.scrolllist-pager-notification[data-direction="backward"]').removeClass('disabled');
            } else {
                $('.scrolllist-pager-notification[data-direction="forward"] .current-page').html(model.PageNumber);
            }

            var indicator = $('.page-indicator', $wrapper).eq(0).clone();
            indicator.attr('data-page', model.PageNumber);
            $('.page-number', indicator).html(model.PageNumber);
            $list.append(indicator);
            $list.append(items);
            $('.page-indicator', $wrapper).removeClass('hidden');
            direction = 'forward';
        }

        if (envelope.message.data.position == 'TopOfList') {
            if (model.PageNumber == 1) {
                $('.scrolllist-pager-notification[data-direction="backward"]').addClass('hidden');
                $('.scrolllist-pager-notification[data-direction="forward"]').removeClass('disabled');
            } else {
                $('.scrolllist-pager-notification[data-direction="backward"] .current-page').html(model.PageNumber);
            }
            var elementFocused = $(' >ul >li', $wrapper).eq(0),
                initPos = elementFocused.parent().offset().top, latePos,
                windowPos = $(window).scrollTop(),
                indicator = $('.page-indicator', $wrapper).eq(0).clone();

            indicator.attr('data-page', model.PageNumber);
            $('.page-number', indicator).html(model.PageNumber);
            $list.prepend(items);
            $list.prepend(indicator);
            $('.page-indicator', $wrapper).removeClass('hidden');
            latePos = elementFocused.offset().top;
            $('html,body').scrollTop(windowPos + latePos - initPos);

            direction = 'backward';
        }

        wrapper.loading(false, direction);
    };

    wrapper.onFailure = function (envelope) {
        if (envelope.message.data.list !== wrapper)
            return;

        var direction = '';

        if (envelope.message.data.position == 'BottomOfList') {
            direction = 'forward';
        }
        if (envelope.message.data.position == 'TopOfList') {
            direction = 'backward';
        }
        wrapper.loading(false, direction);
    };

    wrapper.updatePageUrl = function () {

        if ($wrapper.hasClass('js-redirecting'))
            return;

        var element = Array.from($('>ul>li[data-page]', $wrapper)).filter(function (element) { return $(window).scrollTop() <= $(element).offset().top; })[0],
            pageNumber = $(element).length ? $(element).data('page') : $('>ul>li[data-page]', $wrapper).eq($('>ul>li[data-page]', $wrapper).length - 1).data('page'),
            pager = $('.x-pager[data-page-count]'),
            pageCount = pager.length ? (parseInt(pager.attr('data-page-count')) || 0) : 0,
            comboPagers = $('.pager .x-pager-combopages');

        comboPagers.each(function (index, comboPager) {
            var $comboPager = $(comboPager);
            $('select', $comboPager).addClass('disabled');
            $('.newList>li a', $('select', $comboPager).siblings('.newListSelected')).eq(pageNumber - 1).trigger('click');
            $('select', $comboPager).removeClass('disabled');
        });

        if (history.replaceState) {

            var querystring = window.location.pathname + (window.location.pathname.slice(-1) != "/" ? "/" : ""),
                pageText = pageNumber > 1 ? "p" + pageNumber + "/" : "";

            if (!(/\/P\d+\//i.test(querystring))) {
                querystring = querystring + pageText;
            } else {
                querystring = querystring.replace(/\/P\d+\//i, "/" + pageText);
            }

            var stateObject = {};
            var url = window.location.protocol
                + "//"
                + window.location.host
                + querystring
                + window.location.search;

            if (window.location.href !== url) {
                var prev = $("head link[rel=prev]");
                var next = $("head link[rel=next]");
                var prevLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber - 1) + "$2");
                var nextLink = url.replace(/^(.+\/p)\d+(\/?(\?.*)?)?$/i, "$1" + (pageNumber + 1) + "$2");
                if (prev) {
                    if (pageNumber > 1) {
                        prev.attr("href", prevLink);
                    } else {
                        prev.remove();
                    }
                } else if (pageNumber > 1) {
                    $("head").append("link rel=\"prev\" href=\"" + prevLink + "\" />");
                }
                if (next) {
                    if (pageNumber < pageCount) {
                        next.attr("href", nextLink);
                    } else {
                        next.remove();
                    }
                } else if (pageNumber < pageCount) {
                    $("head").append("link rel=\"next\" href=\"" + nextLink + "\" />");
                }
                history.replaceState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
                //history.pushState(stateObject, jQuery(document).find('title').text() + pageNumber, url);
            }
        }
    };

    wrapper.update = function (dataListMovement) {

        if (loading) return;

        if (dataListMovement == 'forward') {
            hasNext = parseInt($wrapper.attr('data-total-pages')) > parseInt($('>ul>li[data-page]', $wrapper).eq($('>ul>li[data-page]', $wrapper).length - 1).attr('data-page'));
            if (!hasNext) return;
        }
        if (dataListMovement == 'backward') {
            hasPrevious = parseInt($('>ul>li[data-page]', $wrapper).eq(0).attr('data-page')) > 1;
            if (!hasPrevious) return;
        }

        wrapper.loading(true, dataListMovement);

        if (dataListMovement == 'forward') {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetNextPage(wrapper, configuration, 'getTheLookList'));
        }
        if (dataListMovement == 'backward') {
            Vendd.MessageBus.publishAsync(wrapper, new Vendd.ScrollList.Messages.GetPreviousPage(wrapper, configuration, 'getTheLookList'));
        }

    };

    if (isScrolled === true) {
        $(window).scroll($.debounce(300, function () {
            if (($(window).scrollTop() == 0 || $wrapper.offset().top > $(window).scrollTop()) && backwardUpdates < backwardUpdatesCup) {
                backwardUpdates++;
                wrapper.update('backward');
            }
            if (($(window).scrollTop() >= $(document).height() - $(window).height() - $('.footer-region').height() - 500 || isElementInViewport($('.scrolllist-pager-notification'))) && forwardUpdates < forwardUpdatesCup) {
                forwardUpdates++;
                wrapper.update('forward');
            }
            if ($(window).scrollTop() >= 0 && !loading) {
                wrapper.updatePageUrl();
            }
        }));
    }

    //click in order to see more products
    $('.scrolllist-pager-notification').on('click', '.js-show', function () {
        if (!$(this).closest('.scrolllist-pager-notification').hasClass('disabled')) {
            if ($(this).data('direction') === 'forward') forwardUpdates = 0;
            else if ($(this).data('direction') === 'backward') backwardUpdates = 0;
            wrapper.update($(this).data('direction'));
        }
    });

    function wrapBoxes($boxes, grouping, rowSize, lastItem, model) {
        var items = [],
            currentIndex, cssClass;

        lastItem.removeClass('last');

        currentIndex = lastItem.data('index') + 1;

        for (var i = 0; i < $boxes.length; i++) {
            var li = $('<li>');

            cssClass = "item" + currentIndex;
            cssClass += (i === $boxes.length - 1) ? " last" : "";

            li.append($boxes.eq(i))
                .addClass(cssClass)
                .attr('data-index', currentIndex)
                .attr('data-page', model.PageNumber);

            items.push(li);

            currentIndex++;
        }

        return items;
    }

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPageSuccess, wrapper, wrapper.onSuccess);

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetNextPageFailure, wrapper, wrapper.onFailure);

    Vendd.MessageBus.subscribe(Vendd.ScrollList.Messages.GetPreviousPageFailure, wrapper, wrapper.onFailure);

    //bind shopTheLookBox
    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Widget.Messages.BindControl(wrapper));

});